import {Input, message} from 'antd'
import {PasswordService} from 'api'
import Head from 'next/head'
import Router from 'next/router'
import {useState} from 'react'
import {Controller, useForm} from 'react-hook-form'
import {CommonButton} from 'src/common/components/buttons'
import {ButtonBack} from 'src/common/components/buttons/button-back'
import {FormButton} from 'src/common/components/forms/form-button'
import {FormSearchTable} from 'src/common/components/forms/form-search-table'
import {PageTitle} from 'src/common/components/page-title'
import {ResultComponent} from 'src/common/components/result-component'
import pageListAuthen from 'src/common/helpers/page/authen'

const ForgotPasswordContainer = () => {
    const {
        control,
        handleSubmit,
        formState: {errors},
    } = useForm()

    const [openSuccessPage, setOpenSuccessPage] = useState(false)
    const [loading, setLoading] = useState(false)

    const onSubmit = async (data: any) => {
        setLoading(true)
        try {
            const transferData = {
                username: data.username,
                email: data.email,
            }
            await PasswordService.postV1CompanyCommonUsersForgetPassword({requestBody: transferData}).then(() => {
                setOpenSuccessPage(true)
            }).catch(error => {
                if (error.status == 404) {
                    message.error('ログインID及びメールアドレスのに一致するユーザが見つかりません。')
                } else {
                    message.error('パスワードの再設定に失敗しました。')
                    console.error(error)
                }
            }).finally(() => {
                setLoading(false)
            })
        } finally {}
    }

    return (
        <>
            {
                !openSuccessPage ? (
                    <>
                        <Head>
                            <title>{pageListAuthen.forgotPassword.text}</title>
                        </Head>
                        <PageTitle text="パスワード再発行申請"/>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormSearchTable required label="ログインID" className="!mt-[30px]" error={errors?.username?.message}>
                                <Controller
                                    name="username"
                                    rules={{
                                        required: 'ログインIDを入力してください。',
                                        pattern: {
                                            value: /.{4,}/,
                                            message: 'ログインIDは4文字以上で入力してください。',
                                        },
                                    }}
                                    control={control}
                                    render={({field: {onChange, value}}) => <Input size="large" onChange={onChange} value={value}/>}
                                />
                            </FormSearchTable>
                            <FormSearchTable required label="メールアドレス" className="!mt-2" error={errors?.email?.message}>
                                <Controller
                                    name="email"
                                    rules={{
                                        required: '商工会議所メールアドレスを入力してください。',
                                        pattern: {
                                            value:
                                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                            message: 'メールアドレスが正しくありません',
                                        },
                                    }}
                                    control={control}
                                    render={({field: {onChange, value}}) => <Input size="large" onChange={onChange} value={value}/>}
                                />
                                <div className="mt-2">
                                    システムに登録されているログインID及びメールアドレスをご入力のうえ、申請してください。
                                    <br/>
                                    登録されているログインIDまたは、メールアドレスがご不明な場合は、<br />
                                    お手数ですがシステム担当(TEL：045-671-7400 Mail：
                                    <a href="mailto:conference@yokohama-cci.or.jp">conference@yokohama-cci.or.jp</a>)<br/>
                                    までお問い合わせください。
                                </div>
                            </FormSearchTable>

                            <FormButton className="!mt-[50px]">
                                <CommonButton type="primary" loading={loading}>
                                    <span className="font-bold">確認</span>
                                </CommonButton>
                            </FormButton>
                            <ButtonBack onClick={() => Router.push(pageListAuthen.login.url)}/>
                        </form>
                    </>
                ) : (
                    <>
                        <Head>
                            <title>パスワード再設定メールを送信しました。</title>
                        </Head>
                        <ResultComponent
                            status="success"
                            title="パスワード再設定メールを送信しました。"
                            subTitle="メールに記載されているURLをクリックして、パスワードを再設定してください。"
                        />
                    </>
                )
            }
        </>
    )
}

export default ForgotPasswordContainer
